export default "__VITE_ASSET__BIo2oAdj__"